export default defineNuxtPlugin(async (_) => {
	const response = await $fetch(
		"https://download.stockstotrade.com/web_servers.json"
	);
	const web_servers_response: any = response;

	const httpQueryBasedFilterServer =
		web_servers_response.httpQueryBasedFilterServer + "/v1.1/symbols";

	const proxy_urls: { [key: string]: string } = {
		"/proxyServerAddress": web_servers_response.proxyServerAddress,
		"/httpQueryBasedFilterServer": httpQueryBasedFilterServer
	};

	return {
		provide: {
			proxy_urls
		}
	};
});
